//  Node imports
import { ingenuity, ISpineData, SpineBase, IEvent } from "@quest/base-core";
import { BaseViewBehavior } from "@quest/murka-games-behavior-leopard/dist";

export class StackSymbolFeatureViewFG extends BaseViewBehavior {

  /** Resize */
  protected resize(evt: IEvent): void {
    if (!ingenuity.deviceEnv.isDesktop) {
      if (this.CurrentOrientation !== ingenuity.deviceEnv.getOrientation()) {
        this.CurrentOrientation = ingenuity.deviceEnv.getOrientation();
        this.updateOrientation();
      }
    }
  }

  /**
   * method getSpineJsonAndCloneSym: clone spine animation
   */
  public getSpineJsonAndCloneSym(): SpineBase { 
    let stackSpineJsonObj: ISpineData = this.json["character_symbol"];
    stackSpineJsonObj.type = "spine";
    let stackSpineCloneAnim: SpineBase = this.createSpine(stackSpineJsonObj);
    stackSpineCloneAnim.visible = false;
    return stackSpineCloneAnim;
  }


  public getStackTransitionClone(): SpineBase {
    let stackSpineJsonObj: ISpineData = this.json["character_cascade_effect"];
    stackSpineJsonObj.type = "spine";
    let stackSpineCloneAnim: SpineBase = this.createSpine(stackSpineJsonObj);
    stackSpineCloneAnim.visible = false;
    return stackSpineCloneAnim;
  }
}
